import React, { useContext } from 'react';

interface IUrlPreviewContext {
  useUrlPreviewsQuery?: any;
}

export const UrlPreviewContext = React.createContext<Partial<IUrlPreviewContext>>({
  useUrlPreviewsQuery: () => [{}],
});

export const useUrlPreviewContext = () => useContext(UrlPreviewContext);
